import { BaseDummyDriver, prepareTable } from '../index';

const drivers: { [name: string]: BaseDummyDriver } = {};
/**
 *
 * @param name
 */
const clearDriversTable = async (name: string) => {
  try {
    await drivers[name].allLocalTableClear();
  } catch (e) {}
};

/**
 *
 * @param tableName
 * @param primaryKeyName
 * @param secondaryKeyName
 * @param gsiKeyName
 * @param tableDefs
 */
const initCacheDataWithDummyDriver = async (
  tableName: string,
  primaryKeyName: string,
  secondaryKeyName: string,
  gsiKeyName?: string,
  tableDefs?: any
) => {
  drivers[tableName] = new BaseDummyDriver(tableName, primaryKeyName, secondaryKeyName, tableDefs);
  if (!gsiKeyName) {
    await prepareTable(tableName, primaryKeyName, secondaryKeyName, undefined, {
      createAdapter: drivers[tableName].dummyCreateAdapter,
      updateAdapter: drivers[tableName].dummyUpdateAdapter,
      bulkCreateAdapter: drivers[tableName].dummyBulkCreateAdapter,
      bulkUpdateAdapter: drivers[tableName].dummyBulkUpdateAdapter,
      deleteAdapter: drivers[tableName].dummyDeleteAdapter,
      readAdapter2: drivers[tableName].dummyReadAdapter2,
      readAllAdapter: drivers[tableName].dummyReadAllAdapter,
    });
  } else {
    drivers[tableName].setGsiKey(gsiKeyName);
    await prepareTable(tableName, primaryKeyName, secondaryKeyName, undefined, {
      createAdapter: drivers[tableName].dummyCreateAdapter,
      updateAdapter: drivers[tableName].dummyUpdateAdapter,
      bulkCreateAdapter: drivers[tableName].dummyBulkCreateAdapter,
      bulkUpdateAdapter: drivers[tableName].dummyBulkUpdateAdapter,
      deleteAdapter: drivers[tableName].dummyDeleteAdapter,
      readAdapter2: drivers[tableName].dummyReadGsiAdapter,
      readAllAdapter: drivers[tableName].dummyReadAllAdapter,
    });
  }
};

export { initCacheDataWithDummyDriver, clearDriversTable };
